import {
  addCardPaymentMethod,
  tokenizeDestinationCard,
} from "../services/api";
import { brandFromPan, last4 as last4Of } from "./card-brand";
import type { FundingInstrumentNew, FundingInstrumentSaved } from "../interfaces/funding";

export const registerFundingCard = async (
  linkId: string,
  card: FundingInstrumentNew
): Promise<FundingInstrumentSaved> => {
  const cleanedPan = card.pan.replace(/\D/g, "");
  const normalizedBrand = brandFromPan(cleanedPan);
  const last4 = last4Of(cleanedPan);

  const [expiryMonth, expiryYearShort] = card.expiry.split("/");
  const expiryYear = expiryYearShort ? `20${expiryYearShort}` : "";

  let numberToken = card.numberToken;
  if (!numberToken) {
    const tokenized = await tokenizeDestinationCard(cleanedPan);
    numberToken = tokenized.numberToken;
  }

  const cardPayload = {
    tokenizedCardNumber: numberToken,
    tokenizedCvv: card.cvvToken,
    last4,
    brand: card.brand || normalizedBrand,
    expiryMonth,
    expiryYear,
    cardholderName: card.cardholderName.trim(),
    billingAddress: {
      street1: card.billingAddress.street1.trim(),
      street2: card.billingAddress.street2?.trim() || undefined,
      city: card.billingAddress.city.trim(),
      state: card.billingAddress.state.trim().toUpperCase(),
      zipCode: card.billingAddress.zipCode.trim(),
      country: card.billingAddress.country.trim().toUpperCase() || "US",
    },
    validationId: card.cvsValidationId,
  };

  const registered = await addCardPaymentMethod(linkId, cardPayload);

  return {
    source: "saved",
    paymentMethodId: registered.paymentMethodId,
    brand: registered.brand || cardPayload.brand,
    last4: registered.last4 || last4,
    fundingMethod: registered.fundingMethod,
  };
};
